import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormFeedback,
} from "reactstrap"
import { useNavigate, useLocation } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"

import { updateAwardCategory } from "../../../redux/actions/awards"
import { UPDATE_AWARD_CATEGORY_RESET } from "../../../redux/types/awards"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"

function EditAwardCategory() {
  document.title = "Edit Award Category | Admin Dashboard"

  const history = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const { enc_awd_cat_id, category: initialCategory, enc_award_id } =
    location.state || {}

  const editAwardCategoryScreen = useSelector(
    state => state.screens.awards.editAwardCategory
  )

  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  useEffect(() => {
    if (editAwardCategoryScreen && editAwardCategoryScreen.success) {
      setSuccessOpen(true)
    } else if (editAwardCategoryScreen && editAwardCategoryScreen.error) {
      setErrorMsg(editAwardCategoryScreen.error || "Unable to update category.")
      setErrorOpen(true)
    }
  }, [editAwardCategoryScreen])

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      category: initialCategory || "",
    },

    validationSchema: Yup.object({
      category: Yup.string().required("Category name is required"),
    }),

    onSubmit: values => {
      dispatch(
        updateAwardCategory({
          enc_awd_cat_id,
          category: values.category,
        })
      )
    },
  })

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch({ type: UPDATE_AWARD_CATEGORY_RESET })
          history(`/awards/categories/${enc_award_id}`)
        }}
        message="Category updated successfully!"
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch({ type: UPDATE_AWARD_CATEGORY_RESET })
        }}
        message={errorMsg}
      />

      <div className="page-content">
        <Container fluid={true}>
          <div className="mb-3 pb-2"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h2 className="h4 nom-title mb-0">Edit Award Category</h2>
          </div>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      formik.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="category">
                          Category Name
                        </Label>
                        <Input
                          name="category"
                          id="category"
                          className="form-control"
                          placeholder="Enter category name"
                          type="text"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.category || ""}
                          invalid={
                            formik.touched.category && formik.errors.category
                              ? true
                              : false
                          }
                        />
                        {formik.touched.category && formik.errors.category ? (
                          <FormFeedback type="invalid">
                            {formik.errors.category}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>

                    <div className="d-flex gap-2 mt-2">
                      <Button
                        type="submit"
                        color="primary"
                        disabled={editAwardCategoryScreen.loading}
                      >
                        {editAwardCategoryScreen.loading
                          ? "Updating..."
                          : "Update Category"}
                      </Button>
                      <Button
                        type="button"
                        color="secondary"
                        onClick={() => history(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditAwardCategory
